var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewerror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_63_1",
    "data-name": "Component 63 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 169.908,
    viewBox: "0 0 232 169.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(-6 -200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17251",
    "data-name": "Rectangle 17251",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "matrix(0.997, 0.079, -0.079, 0.997, 21.294, 233.688)",
    fill: "#d858fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17252",
    "data-name": "Rectangle 17252",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "matrix(0.985, 0.175, -0.175, 0.985, 174.564, 220.078)",
    fill: "#6dd400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17253",
    "data-name": "Rectangle 17253",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(94.487 321.132) rotate(-64.766)",
    fill: "#fbb700"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17254",
    "data-name": "Rectangle 17254",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(222.385 328.163) rotate(-30.048)",
    fill: "#ff4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17255",
    "data-name": "Rectangle 17255",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(20.128 349.754) rotate(-55.466)",
    fill: "#ff4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17256",
    "data-name": "Rectangle 17256",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(233.879 285.673) rotate(171.397)",
    fill: "#d858fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17257",
    "data-name": "Rectangle 17257",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(89.282 206.957) rotate(-30.048)",
    fill: "#32baec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17258",
    "data-name": "Rectangle 17258",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(6 305.112) rotate(-30.048)",
    fill: "#6dd400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17259",
    "data-name": "Rectangle 17259",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "matrix(0.727, 0.687, -0.687, 0.727, 157.408, 244.615)",
    fill: "#ff4848"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10458",
    "data-name": "Group 10458",
    transform: "translate(-604 -254.092)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1066",
    "data-name": "Ellipse 1066",
    cx: 69,
    cy: 69,
    r: 69,
    transform: "translate(651 286)",
    fill: "#ff9e9d",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1065",
    "data-name": "Ellipse 1065",
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(665 299)",
    fill: "#ff8280",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10457",
    "data-name": "Group 10457",
    transform: "translate(596.514 63.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(101.486 269.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box",
    transform: "translate(0 -0.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17225",
    "data-name": "Rectangle 17225",
    width: 44,
    height: 44,
    transform: "translate(0 -0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.812 2.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8983",
    "data-name": "Path 8983",
    d: "M21.934,5.624A16.309,16.309,0,1,1,5.624,21.934,16.309,16.309,0,0,1,21.934,5.624m0-3.624A19.843,19.843,0,1,0,36.056,7.812,19.934,19.934,0,0,0,21.934,2Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8976",
    "data-name": "Path 8976",
    d: "M25.692,23.151l5.074-4.983a1.9,1.9,0,0,0,.181-2.446,1.722,1.722,0,0,0-2.718-.181l-5.074,5.074L18.081,15.54a1.722,1.722,0,0,0-2.718.181,1.9,1.9,0,0,0,.181,2.446l5.074,4.983-5.074,4.983a1.9,1.9,0,0,0-.181,2.446,1.722,1.722,0,0,0,2.718.181l5.074-5.074,5.074,5.074a1.722,1.722,0,0,0,2.718-.181,1.9,1.9,0,0,0-.181-2.446Z",
    transform: "translate(-3.221 -3.217)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewerror);
export default __webpack_public_path__ + "static/media/reviewerror.317e7d94.svg";
export { ForwardRef as ReactComponent };